import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Css from './SkeletonItems.module.css';

const SkeletonItemsMoby = (props) => {
    return (
        <>
            <div className={Css.content} >
                <Skeleton variant="rectangular" width="95%" height={168} sx={{ mt: 1 }} />
                <Skeleton variant="rectangular" width="60%" height={8} sx={{ mt: 2 }} />
                <Skeleton variant="rectangular" width="80%" height={21} sx={{ mt: 2 }} />
                <Skeleton variant="rectangular" width="80%" height={8} sx={{ mt: 1 }} />
                <Skeleton variant="rectangular" width="40%" height={21} sx={{ mt: 2 }} />
            </div>
        </>
    )
}

export default SkeletonItemsMoby;